import { render, staticRenderFns } from "./Killers.vue?vue&type=template&id=d8eadbf8"
import script from "./Killers.vue?vue&type=script&lang=ts"
export * from "./Killers.vue?vue&type=script&lang=ts"
import style0 from "./Killers.vue?vue&type=style&index=0&id=d8eadbf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports